import React from "react";
import PortraitSurf from "../../images/portrait_surf.jpg";
import PortraitFishing from "../../images/portrait_fishing.jpg";
import PortraitTrips from "../../images/portrait_trips.jpg";
// import PortraitHorseRiding from "../../images/portrait_horseriding.jpg";

import BackgroundSurf from "../../images/background_surf.jpg";
import BackgroundFishing from "../../images/background_fishing.jpg";
import BackgroundTrips from "../../images/background_trips.jpg";
import { waMessages } from "../../Utils/waMessages";
// import BackgroundHorseRiding from "../../images/background_horseriding.jpg";

export const activities = [
  {
    id: 1,
    title: "Surf",
    location: (
      <>
        <a
          href="https://maps.app.goo.gl/jwZb4upKf448qzef9"
          target="_blank"
          rel="noopener noreferrer"
        >
          Playa La Punta
        </a>
        ,{" "}
        <a
          href="https://maps.app.goo.gl/mFNy5TvUra3Kj7aF8"
          target="_blank"
          rel="noopener noreferrer"
        >
          Playa Carrizalillo
        </a>{" "}
        y{" "}
        <a
          href="https://maps.app.goo.gl/fLFVcHTu8nW4GvrZ6"
          target="_blank"
          rel="noopener noreferrer"
        >
          Playa Zicatela
        </a>
        . Puerto Escondido, Oaxaca
      </>
    ),
    overview: (
      <>
        Algo
        <div className="paragraph_break" />
      </>
    ),
    cost: "$1,000",
    costDescription: "Por Clase",
    buttonText: "Reservar Tu Clase",
    details: (
      <p>
        <span>Horarios:</span>
        <br />
        <span>Lunes a Viernes:</span> 7am, 10am y 4pm. <br />
        <span>Sábados y domingos:</span> 10am y 1pm. <br />
        <span>Duración de 2 horas:</span> 30 minutos de teoría básica y 90
        minutos en el agua practicando.
        <br />
        <span>Capacidad máxima:</span> 4 personas.
      </p>
    ),
    fontColor: "white",
    calendarSource:
      "c_b22949f96e30216fd8b4633233d895d1267df7cc715e5496f58852649ad91360%40group.calendar.google.com",
    portrait: PortraitSurf,
    background: BackgroundSurf,
    whatsappMessage: waMessages.activitiesSurf,
  },
  {
    id: 2,
    title: "Pesca Deportiva",
    location: (
      <>
        <a
          href="https://maps.app.goo.gl/FzWfsg5f4bZd9dvW9"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bahia Principal.
        </a>{" "}
        Puerto Escondido, Oaxaca
      </>
    ),
    overview: (
      <>
        Adéntrate en las aguas del Pacífico, reconocidas como una de las mejores
        zonas de pesca en México, y vive la experiencia única de capturar
        especies emblemáticas como pez vela, atún, marlín, dorado, sierra y
        mucho más. <div className="paragraph_break" />
        Ya sea que seas un pescador experimentado o un principiante, nuestras
        excursiones son perfectas para compartir con amigos y familiares
        mientras disfrutas de vistas espectaculares y la emoción de la pesca en
        alta mar. <div className="paragraph_break" />
        ¡Prepárate para la captura de tu vida y crea recuerdos inolvidables en
        Puerto Escondido!
      </>
    ),
    cost: "$1,200",
    costDescription: "Por Persona",
    buttonText: "Reserva Tu Viaje",
    details: (
      <p>
        <span>Horario:</span> De 7am a 12pm.
        <br />
        <span>Duración: </span> 5 horas.
        <br />
        <span>Capacidad máxima:</span> 5 personas.
      </p>
    ),
    fontColor: "white",
    calendarSource:
      "c_8673710f2839758d5f5581760f26adcbf185e1785b63668f965405ebbf5db062@group.calendar.google.com",
    portrait: PortraitFishing,
    background: BackgroundFishing,
    whatsappMessage: waMessages.activitiesFishing,
  },
  {
    id: 3,
    title: "Viajes de Surf",
    location: (
      <>
        <a
          href="https://maps.app.goo.gl/FzWfsg5f4bZd9dvW9"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bahia Principal.
        </a>{" "}
        Puerto Escondido, Oaxaca
      </>
    ),
    overview: (
      <>
        Tal como Puerto Escondido, hogar de olas legendarias, toda la costa de
        Oaxaca te invita a descubrir una infinidad de surf spots únicos, desde
        playas icónicas hasta secretos escondidos que esperan ser conquistados.
        <div className="paragraph_break" />
        Vive la emoción de surfear en el Pacífico oaxaqueño con la guía de
        expertos locales que te llevarán a los mejores lugares, compartiendo su
        conocimiento y la auténtica vibra surfer.
        <div className="paragraph_break" />
        ¡Embárcate en esta aventura única, conecta con el océano y surfea las
        mejores olas de tu vida!
      </>
    ),
    cost: "$0",
    costDescription: "Por Persona",
    buttonText: "Reserva Tu Viaje",
    details: null,
    fontColor: "white",
    calendarSource:
      "c_98d23d54fc8be140670a0e2cf833044bd9179800e01f4b008a07c2816b44ce80@group.calendar.google.com",
    portrait: PortraitTrips,
    background: BackgroundTrips,
    whatsappMessage: waMessages.activitiesTrips,
  },
  // {
  //   id: 4,
  //   title: "",
  //   location: (
  //     <>
  //       <a
  //         href="https://maps.app.goo.gl/jwZb4upKf448qzef9"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Playa La Punta.
  //       </a>{" "}
  //       Puerto Escondido, Oaxaca
  //     </>
  //   ),
  //   overview: (<>Something</>),
  //   cost: "$0",
  //   costDescription: "",
  //   buttonText: "",
  //   details: null,
  //   fontColor: "",
  //   calendarSource: "",
  //   portrait: ,
  //   background: ,
  // },
];
